import React from "react";

import { Box, Stack, TextField, Typography, useTheme } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";

import dayjs from "dayjs";

import { PublishingDaysExceptionSchema } from "../../types";
import RemoveButton from "../RemoveButton";

export interface PublicationDateRowProps {
  isEditing: boolean;
  initialDate: PublishingDaysExceptionSchema;
  onUpdate: (newDate: PublishingDaysExceptionSchema) => void;
  onDelete: () => void;
}

const PublicationDateRow: React.FC<PublicationDateRowProps> = ({
  isEditing,
  initialDate,
  onUpdate,
  onDelete,
}) => {
  const theme = useTheme();

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onUpdate({ ...initialDate, day_name: event.target.value });
  };

  const handleDateChange = (date: dayjs.Dayjs | null) => {
    if (date) {
      onUpdate({ ...initialDate, date: date.format("YYYY-MM-DD") });
    }
  };

  return isEditing ? (
    <Stack direction="row" gap={1} gridColumn="span 4">
      <TextField
        size="small"
        sx={{
          flex: 1,
          bgcolor:
            theme.palette.mode === "dark"
              ? theme.palette.grey[900]
              : theme.palette.common.white,
        }}
        value={initialDate.day_name}
        variant="outlined"
        onChange={handleNameChange}
      />
      <DatePicker
        slotProps={{
          textField: {
            size: "small",
            sx: {
              flex: 1,
              bgcolor:
                theme.palette.mode === "dark"
                  ? theme.palette.grey[900]
                  : theme.palette.common.white,
            },
          },
        }}
        value={dayjs(initialDate.date)}
        onChange={handleDateChange}
      />
      <RemoveButton onClick={onDelete} />
    </Stack>
  ) : (
    <Box
      key={initialDate.date}
      display="grid"
      gap={1}
      gridColumn="span 4"
      gridTemplateColumns="subgrid"
    >
      <Typography sx={{ gridColumn: "span 1" }} variant="body2">
        {initialDate.day_name}
      </Typography>
      <Typography sx={{ gridColumn: "span 1" }} variant="body2">
        {initialDate.date}
      </Typography>
    </Box>
  );
};

export default PublicationDateRow;
